module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAVZJREFUOBGtlb1xwkAQhREzykic2gXQgFNMCyagBJrAHeA6yD3ERI5pAI9jNUDoMfL32XeMOHGW8WhnHqvbfft0P3uiGFywuq5Lwo8B9/jbQKvwO/AiiqL4CPG8Q2wG3sEWLMAYjAJ8NmZOziyrRHIIVuANTLPEkJATuNYMW3yCJl7BTSuZCcgNNaszCkGX6cz+LBYFrAm1P8tnUAL3o7VMYhOwAVWAz5MoFj2xKVCjHPAzB9uYjJ7YEhxBap8ElpEXPTEPaq7gGixiQs/YmVmYM3NnM2Xs6a8t3oNxIujSumyT1NhSewUPYJQk3bMus8lPBtlePbT750S5+qGwQkHfdOegYV6vLks5Xs9KQRMPSfUz42MSaw7NyWmaGjv3MNc2T+QunbSxX9um38Z2zryxv6sXNwHR/j4OYZb9fr4aM3X5XnTvptfpqg/sdzNGsegR+fdfwBcVxD+jGM6M/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/circleChoose.png
// module id = fpJn
// module chunks = 1